import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.inquiries.share;
export const inquiriesShareInquiryIdSelector = (state: RootState) => getState(state).shareInquiryId;
export const inquiriesShareSelectedSupplementsSelector = (state: RootState) =>
  getState(state).shareSelectedSupplements;
export const inquiriesShareUrlSelector = (state: RootState) => getState(state).shareUrl;
export const inquiriesShareUrlIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const inquiriesShareUrlErrorSelector = (state: RootState) => getState(state).error;
export const sharedInquiryResponseSelector = (state: RootState) => getState(state).sharedResponse;
